<div class="w-16 h-16 border border-grey-300 inline-block p-1" [ngClass]="{'bg-grey-300':!isFocus}">
  <p class="text-sm">{{this.displayDay}}</p>

  @if (this.events.length > 0) {
    <div class="rounded-full bg-green-300 text-standardwhite w-5 h-5 text-center mt-1 hover:cursor-pointer" (click)="dateClicked()">
      <span class="text-sm block" >{{this.events.length}}</span>
    </div>
  }
</div>
